var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradient2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 309,
    viewBox: "0 0 1440 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3090_5777)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3090_5777)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.5,
    cy: 442.5,
    rx: 481.5,
    ry: 144.5,
    fill: "url(#paint0_linear_3090_5777)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3090_5777)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.5,
    cy: 377,
    rx: 481.5,
    ry: 74,
    fill: "url(#paint1_linear_3090_5777)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3090_5777",
    x: -74,
    y: -14,
    width: 1587,
    height: 913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 156,
    result: "effect1_foregroundBlur_3090_5777"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3090_5777",
    x: 174,
    y: 239,
    width: 1091,
    height: 276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32,
    result: "effect1_foregroundBlur_3090_5777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3090_5777",
    x1: 238,
    y1: 442.5,
    x2: 1201,
    y2: 442.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#3E90B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#454DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C47A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3090_5777",
    x1: 238,
    y1: 377,
    x2: 1201,
    y2: 377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#3E90B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#454DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C47A2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3090_5777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1713,
    height: 1069,
    fill: "white",
    transform: "translate(-137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient2);
export default __webpack_public_path__ + "static/media/gradient2.1f221092ba7b5a6ed9408a5426d5081d.svg";
export { ForwardRef as ReactComponent };